import React from 'react';

const Welcome = () => {
  return (<div className="grid-choose-option view-pager-panel">
    <h2>{API.LANG.WELCOME}</h2>
    <div className="img-container">
      <img src={API.IMG + 'Package.png'} alt=""/>
    </div>
    <p> {API.LANG.ON_BOARD} </p>
  </div>);
};
const SearchPage = () => {
  return (<div className="grid-choose-option view-pager-panel">
    <h2>{API.LANG.STEP_1}</h2>
    <div className="img-container">
      <img className="box-shadow" src={API.IMG + 'first-step.png'} alt=""/>
    </div>
    <p> {API.LANG.CREATE_SEARCH} </p>
  </div>);
};
const GridOption = () => {
  return (<div className="grid-choose-option view-pager-panel">
    <h2>{API.LANG.STEP_2}</h2>
    <div className="img-container">
      <img src={API.IMG + 'second-step.png'} alt=""/>
    </div>
    <p>{API.LANG.WISH_LETTER} </p>
  </div>);
};
const SearchOption = () => {
  return (<div className="grid-choose-option view-pager-panel">
    <h2>{API.LANG.STEP_3}</h2>
    <div className="img-container">
      <img src={API.IMG + 'third-step.png'} alt=""/>

    </div>
    <p>{API.LANG.BEAST_RELEASE}</p>
  </div>);
};
const PostSelect = () => {
  return (<div className="grid-choose-option view-pager-panel">
    <h2>{API.LANG.STEP_4}</h2>
    <div className="img-container">
      <img src={API.IMG + 'forth-step.png'} alt=""/>

    </div>
    <p>{API.LANG.DATA_CONTROL}</p>
  </div>);
};
const Congrates = () => {
  return (<div className="grid-choose-option view-pager-panel">
    <h2>{API.LANG.READY}</h2>
    <div className="img-container">
      <img src={API.IMG + 'Processing.png'} alt=""/>
    </div>

    <p>{API.LANG.FOLLOW}
       <a href="https://redq.gitbooks.io/reactive/content/">{API.LANG.REACTIVE_DOC_LINK}</a>
       {API.LANG.FURTHER_QUERIES}
       <a href="mailto:support@redqteam.com">{API.LANG.REDQ_EMAIL}</a>
       {API.LANG.LET_US_KNOW}
    </p>
  </div>);
};

class ViewPagerPanel extends React.Component {
  constructor(props) {
    super(props);
    this.viewPagerElementArray = [
      {
        item: <Welcome />,
        'image_url': API.IMG + 'package.png',
      }, {
        item: <SearchPage />,
        'image_url': API.IMG + 'first-step.png',
      }, {
        item: <GridOption />,
        'image_url': API.IMG + 'second-step.png',
      }, {
        item: <SearchOption />,
        'image_url': API.IMG + 'third-step.png',
      }, {
        item: <PostSelect />,
        'image_url': API.IMG + 'forth-step.png',
      }, {
        item: <Congrates />,
        'image_url': API.IMG + 'Processing.png',
      },
    ];
    this.state = { windowValue: 0 };
    this.previousWindow = this.previousWindow.bind(this);
    this.nextWindow = this.nextWindow.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }
  previousWindow() {
    if (this.state.windowValue > 0) {
      const windowValue = this.state.windowValue - 1;
      this.setState({ windowValue });
    }
  }
  nextWindow() {
    if (this.state.windowValue < this.viewPagerElementArray.length - 1) {
      const windowValue = this.state.windowValue + 1;
      this.setState({ windowValue });
    }
  }
  handleCloseModal() {
    localStorage.setItem('reactiveSiteTour', 'true');
    this.props.onCloseModal();
  }
  render() {
    let prevButton = true;
    let nextButton = true;
    let finishButton = false;
    if (this.state.windowValue === 0) {
      prevButton = false;
    }
    if (this.state.windowValue === this.viewPagerElementArray.length - 1) {
      nextButton = false;
    }
    if (this.state.windowValue === this.viewPagerElementArray.length - 1) {
      finishButton = true;
    }
    return (<div>
      <div className="grid-choose-option view-pager-img">
      </div>
      {this.viewPagerElementArray[this.state.windowValue].item}
      <div className="add-button-content view-agerpanerl-button">
        <div className="right-btn">
          <button className="view-pager-button" onClick={this.handleCloseModal}>{API.LANG.SKIP}</button>
        </div>
        <div className="left-btn">
          {nextButton ? <button className="view-pager-button" onClick={this.nextWindow}>{API.LANG.NEXT}</button> : null}
          {finishButton ? <button className="view-pager-button" onClick={this.handleCloseModal}>{API.LANG.FINISH}</button> : null}
          {prevButton ? <button className="view-pager-button previous" onClick={this.previousWindow}>{API.LANG.PREVIOUS}</button> : null}
        </div>
      </div>
    </div>);
  }
}

export default ViewPagerPanel;



// WEBPACK FOOTER //
// ./assets/src/frontend/panel/viewPagerPanel.js